import { Input } from "../../ui/input";
import { DdxList, BulletList } from "../../common";

const YesNo = ({ i, value, onAnswer }) => (
  <div className="flex gap-1">
    {["Yes", "No", "Unknown"].map((o) => (
      <button key={o} data-testid={`followup-q-${i}-${o.toLowerCase()}`} onClick={() => onAnswer(o)}
        className={`cc-toggle flex-1 ${value === o ? "is-on" : ""}`}>{o}</button>
    ))}
  </div>
);

export const QuestionRow = ({ q, i, value, onAnswer }) => (
  <div className="p-5 grid md:grid-cols-[1fr_280px] gap-3 items-center" data-testid={`followup-q-${i}`}>
    <div>
      <div className="font-medium">{q.question}</div>
      {q.purpose && <div className="text-xs text-muted-foreground mt-1">{q.purpose}</div>}
    </div>
    {q.type === "yesno" ? <YesNo i={i} value={value} onAnswer={onAnswer} /> : (
      <Input data-testid={`followup-q-${i}-text`} value={value || ""} onChange={(e) => onAnswer(e.target.value)} className="cc-input" placeholder="Answer" />
    )}
  </div>
);

export const TentativeView = ({ t }) => (
  <div className="mt-10 space-y-4">
    <h2 className="font-heading text-lg font-semibold">Tentative Differential Diagnosis</h2>
    {t.summary && <p className="text-sm text-muted-foreground" data-testid="tentative-summary">{t.summary}</p>}
    <DdxList items={t.ddx} testid="tentative-ddx" />
    {t.red_flags?.length > 0 && (
      <div className="border-l-4 border-[var(--cc-red)] bg-card p-4 text-sm" data-testid="red-flags">
        <div className="cc-label text-[var(--cc-red)] mb-1">Red flags</div>
        <BulletList items={t.red_flags} className="list-disc pl-5" />
      </div>
    )}
  </div>
);

export const NeedsHistoryNotice = () => (
  <div className="border-l-4 border-[var(--cc-amber)] bg-card p-4 text-sm" data-testid="followup-needs-history">
    Enter the chief complaints in Step 1 first, then the focused questions will be generated automatically.
  </div>
);
